import { useState, useEffect } from "react";
import Modal from "components/ui/modals";
import { useOrderHeader } from "hooks/order";

export default function SetItemDetail() {
  const { 
    isItemDetailModalOpen, 
    setItemDetailModalOpen, 
    editingItemIndex, 
    setEditingItemIndex,
    rateOrderItems,
    setRateOrderItems 
  } = useOrderHeader();
  
  const [itemDetails, setItemDetails] = useState("");

  useEffect(() => {
    if (isItemDetailModalOpen && editingItemIndex !== null && rateOrderItems[editingItemIndex]) {
      setItemDetails(rateOrderItems[editingItemIndex].itemdetails || "");
    }
  }, [isItemDetailModalOpen, editingItemIndex, rateOrderItems]);

  const handleSave = () => {
    if (editingItemIndex !== null) {
      setRateOrderItems(
        rateOrderItems.map((item, index) =>
          index === editingItemIndex 
            ? { ...item, itemdetails: itemDetails }
            : item
        )
      );
    }
    handleClose();
  };

  const handleClose = () => {
    setItemDetailModalOpen(false);
    setEditingItemIndex(null);
    setItemDetails("");
  };

  const currentItem = editingItemIndex !== null ? rateOrderItems[editingItemIndex] : null;

  return (
    <Modal
      open={isItemDetailModalOpen}
      setOpen={setItemDetailModalOpen}
      maxWidth="md"
      header={
        <div>
          <h3 className="text-lg font-semibold leading-6 text-gray-900">Add Item Details</h3>
          {currentItem?.itemname?.label && (
            <p className="mt-0.5 text-sm text-gray-500">{currentItem.itemname.label}</p>
          )}
        </div>
      }
      footer={
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={handleClose}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Save
          </button>
        </div>
      }
    >
      <div>
        <label htmlFor="comment" className="block text-sm font-medium leading-6 text-gray-900 mb-2">
          Item Detail Comments
        </label>
        <textarea
          rows={4}
          name="comment"
          id="comment"
          placeholder="Add item detail comments..."
          className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          value={itemDetails}
          onChange={(e) => setItemDetails(e.target.value)}
        />
      </div>
    </Modal>
  );
}
